export default __webpack_public_path__ + "static/media/2444.e665df60.png";